import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import { getPageProps } from "@services/initial-calls";
import TermsAndConditions from "@components/shared/legal/termsAndConditions";
import TopCommercialCleanersWrapper from "@components/layouts/topcommercialcleanersWrapper";

export default function InsureYourCarHome(): ReactElement {
    return (
        <TopCommercialCleanersWrapper>
            <TermsAndConditions
                category="Commercial Cleaners"
                domain="TopCommercialCleaners.com"
            />
        </TopCommercialCleanersWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", {
        pageTitle: "Terms And Conditions",
    });
};
